import { render } from "./AllTrs.vue?vue&type=template&id=1d6fad69&ts=true"
import script from "./AllTrs.vue?vue&type=script&lang=ts"
export * from "./AllTrs.vue?vue&type=script&lang=ts"

import exportComponent from "/home/vaab/dev/js/monujo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__